module.exports = __webpack_public_path__ + "static/media/d9.f40867b2.png";